import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/animations.css";

function Archive() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const years = [
    { year: 2015, description: "Portfolio refresh with acting focus", href: "/archives/2015/index.html" },
    { year: 2013, description: "Redesign with modern web technologies", href: "/archives/2013/index.html" },
    { year: 2009, description: "Early portfolio experiments", href: "/archives/2009/index.html" },
    { year: 2006, description: "Early e-portfolio (frameset)", href: "/archives/2006/index.html" },
  ];

  return (
    <main className="flex-1 w-full px-4 md:px-6 py-12 max-w-4xl mx-auto" style={{
      animation: isLoaded ? 'fadeIn 0.6s ease-out' : 'fadeIn 0.6s ease-out',
    }}>
      <Link to="/" className="inline-flex items-center text-blue-400 hover:text-blue-300 mb-8 transition-colors font-semibold" style={{
        animation: 'cascadeIn 0.6s ease-out 0.1s backwards'
      }}>
        <span className="mr-2">←</span> Back to Home
      </Link>

      <h1 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{
        animation: 'cascadeIn 0.6s ease-out 0.2s backwards'
      }}>Site Archive</h1>

      <div className="space-y-6 mb-12">
        {years.map((item, idx) => (
          <div key={idx} className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-xl p-6 hover:border-slate-600 transition-colors" style={{
            animation: `cascadeIn 0.6s ease-out ${0.3 + idx * 0.1}s backwards`
          }}>
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold text-white">{item.year}</h2>
                <p className="text-gray-400 mt-2">{item.description}</p>
              </div>
              <a 
                href={item.href ?? `/archives/${item.year}`}
                className="px-6 py-2 bg-blue-600/20 border border-blue-500/30 text-blue-300 hover:bg-blue-600/40 rounded-lg transition-colors whitespace-nowrap ml-4"
              >
                View Site
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center text-gray-500 text-sm">
        <p>© {new Date().getFullYear()} Walt Yao. All rights reserved.</p>
      </div>
    </main>
  );
}

export default Archive;
